import { Fragment, useEffect } from "react";
import ImageView from "../components/ImageView";
import VideoPopup from "../components/VideoPopup";
import { animation } from "../utils";
import Footer from "./footer/Index";
import ScrollTopButton from "./ScrollTopButton";

const Layout = ({ children }) => {
  useEffect(() => {
    animation();
  }, []);

  return (
    <Fragment>
      <VideoPopup />
      <ImageView />
      <div className="page-wrapper">
        {/* Preloader */}
        {/* <Preloader /> */}
        {children} {/* Children will include Header and other components */}
        <Footer />
      </div>
      <ScrollTopButton />
    </Fragment>
  );
};

export default Layout;
